<app-header></app-header>
<div *ngIf="showUpdateBanner" class="update-banner">
  <span>
    A new version of this site is available.
    <button class="btn-reload" (click)="reloadPage()">Reload</button>
  </span>
</div>
<div class="content" role="main">
  <router-outlet></router-outlet>
</div>

<!-- Release Notes Modal as component -->
<app-release-notes [show]="showAnnouncement" (dismiss)="onAcknowledgeAnnouncement()">
</app-release-notes>

<!-- Settings Modal -->
<app-settings></app-settings>

<!-- Only show footer if not on the login/landing page -->
<app-footer *ngIf="!isLoginPage()"></app-footer>